import { get } from "svelte/store";
import { ActiveTopicStore, ActiveTopic } from "./extension/ActiveTopicStore";
import { TopicAccessLevel } from "./extension/ActiveTopicStore";
import { TokenStore } from "./TokenStore";
import { TenantStore } from "./TenantStore";
import { LocalStorage } from "../services/LocalStorage";
import { ClusterStore } from "./ClusterStore";
import { PreferencesStore } from "./global/PreferencesStore";
import { ExtensionStore } from "./ExtensionStore";
import { getRole, removeUrlParameters } from "$/utils/Utils";

export async function extensionInit(minimalTopicAccessLevel = TopicAccessLevel.VIEWER) {
    ExtensionStore.setLoadingStatus(true);
    await initializeStores();
    await loadInitialTopic(minimalTopicAccessLevel);
    ExtensionStore.setLoadingStatus(false);
}

async function initializeStores() {
    if (get(TenantStore) === null) await TenantStore.init();
    if (get(ClusterStore).clusters === null) await ClusterStore.init(get(TenantStore).active.id);
}

async function loadInitialTopic(minimalTopicAccessLevel) {

    const preferences = get(PreferencesStore);
    const topics = ClusterStore.getAllClusterTopics();

    if (preferences.openInboxOnStartup) {
        await ActiveTopicStore.init(null, TokenStore, TenantStore, ClusterStore);
        return;
    }

    if(preferences.openByUrlOnStartup) {
        const currentUrl = window.location.href.split('#')[0];

        const latestTopicWithSameUrl = topics
            .filter( topic => topic.url && removeUrlParameters(topic.url) === removeUrlParameters(currentUrl))
            .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))[0];

        if (latestTopicWithSameUrl) {
            await ActiveTopicStore.init(latestTopicWithSameUrl.id, TokenStore, TenantStore, ClusterStore);
            return;
        }
    }

    const previouslySavedActiveTopicId = await LocalStorage.get("activeTopicId");
    const currentActiveTopic = get(ActiveTopic);

    if (currentActiveTopic === null) {
        await selectTopicToLoad(previouslySavedActiveTopicId, minimalTopicAccessLevel, topics);
    }
}

async function selectTopicToLoad(previouslySavedActiveTopicId, minimalTopicAccessLevel, topics) {

    const previouslySavedActiveTopic = topics.find(
        (topic) => topic.id === previouslySavedActiveTopicId
    );

    const role = getRole(
        previouslySavedActiveTopic,
        get(TokenStore).user?.id,
        get(TenantStore).tenants,
        get(ClusterStore).clusters,
    );

    if (previouslySavedActiveTopicId === null || role < minimalTopicAccessLevel) {
        await loadTopic({id: null});
        return;
    }

    if (previouslySavedActiveTopic) {
        await loadTopic(previouslySavedActiveTopic);
    } else if (topics.length > 0) {
        const firstNonArchivedTopic = ClusterStore.getFirstNonArchivedTopic();
        const topicToLoad = firstNonArchivedTopic || topics[0];
        await loadTopic(topicToLoad);
    } else {
        ActiveTopicStore.clear();
    }
}

async function loadTopic(topic) {
    await ActiveTopicStore.init(topic.id, TokenStore, TenantStore, ClusterStore);
}
